export default __webpack_public_path__ + "static/illustration-building-toolbox-97955f08b74f68b92b9411fb9e927815.svg";